"use strict";

exports.__esModule = true;
exports.getObjectFirstAttribute = exports.getClientRect = void 0;

var getClientRect = function getClientRect(elem) {
  if (!elem || !elem.getBoundingClientRect || typeof elem.getBoundingClientRect !== "function") {
    return {
      width: 0,
      x: 0,
      x2: 0
    };
  }

  var _elem$getBoundingClie = elem.getBoundingClientRect(),
      _elem$getBoundingClie2 = _elem$getBoundingClie.left,
      left = _elem$getBoundingClie2 === void 0 ? 0 : _elem$getBoundingClie2,
      _elem$getBoundingClie3 = _elem$getBoundingClie.width,
      width = _elem$getBoundingClie3 === void 0 ? 0 : _elem$getBoundingClie3,
      _elem$getBoundingClie4 = _elem$getBoundingClie.right,
      right = _elem$getBoundingClie4 === void 0 ? 0 : _elem$getBoundingClie4;

  return {
    width: width,
    x: +left,
    x2: +right
  };
};

exports.getClientRect = getClientRect;

var getObjectFirstAttribute = function getObjectFirstAttribute(data) {
  for (var key in data) {
    return data[key];
  }
};

exports.getObjectFirstAttribute = getObjectFirstAttribute;